/* Original Renegade v44 — restock availability enquiry, separate from marketing consent. */
(function(){
'use strict';
var main=document.querySelector('[data-or-product-main]');
var restock=document.querySelector('[data-or-restock-notify]');
if(!main||!restock||restock.dataset.orRestockReady==='1')return;
restock.dataset.orRestockReady='1';

var productForm=main.querySelector('.or-product-form');
if(productForm&&productForm.parentNode){productForm.parentNode.insertBefore(restock,productForm.nextSibling)}

var configNode=main.querySelector('[data-product-config]'),config={};
try{config=configNode?JSON.parse(configNode.textContent):{}}catch(error){config={}}
var variants=Array.isArray(config.variants)?config.variants:[];
var optionNames=Array.isArray(config.optionNames)?config.optionNames:[];
var idInput=main.querySelector('[data-selected-variant-id]');
var form=restock.querySelector('form');
var email=restock.querySelector('[data-restock-email]');
var tagsInput=restock.querySelector('[data-restock-tags]');
var selection=restock.querySelector('[data-restock-selection]');
var fields=restock.querySelector('[data-restock-fields]');
var success=restock.querySelector('[data-restock-success]');
var successSelection=restock.querySelector('[data-restock-success-selection]');
var status=restock.querySelector('[data-restock-status]');
var submittedSuccess=!!success;
var xflowObserver=null;
function xflowActive(){
  return !!document.querySelector('.xflow-button,xflow-bis-button-product-card,[data-xflow-bis-button],[data-xflow-button]');
}
function standDownForXflow(){
  if(!xflowActive())return false;
  restock.hidden=true;
  restock.setAttribute('data-or-xflow-active','true');
  if(xflowObserver){xflowObserver.disconnect();xflowObserver=null}
  return true;
}

function preferencesProcessingAllowed(){
  try{
    return !!(
      window.Shopify&&
      window.Shopify.customerPrivacy&&
      typeof window.Shopify.customerPrivacy.preferencesProcessingAllowed==='function'&&
      window.Shopify.customerPrivacy.preferencesProcessingAllowed()
    );
  }catch(error){
    return false;
  }
}

var storageKey='or-restock-variant-'+String(restock.dataset.productId||'product');
var storedVariantId='';
if(preferencesProcessingAllowed()){
  try{storedVariantId=window.sessionStorage.getItem(storageKey)||''}catch(error){}
}
var successVariantId=submittedSuccess?(storedVariantId||(idInput&&idInput.value?String(idInput.value):'')):'';
var successVariant=successVariantId?variants.find(function(variant){return String(variant.id)===String(successVariantId)})||null:null;
if(submittedSuccess&&preferencesProcessingAllowed()){
  try{window.sessionStorage.removeItem(storageKey)}catch(error){}
}

function currentVariant(){
  var id=idInput&&idInput.value?String(idInput.value):'';
  return id?variants.find(function(variant){return String(variant.id)===id})||null:null;
}

function selectedOptionsFromDom(){
  return optionNames.map(function(_,index){
    var active=main.querySelector('.variant-btn[data-option-index="'+index+'"].is-active');
    return active?active.dataset.value:null;
  });
}

function candidateVariants(optionIndex,value,selected){
  return variants.filter(function(variant){
    if(String(variant.options[optionIndex])!==String(value))return false;
    return selected.every(function(selectedValue,index){
      if(index===optionIndex||selectedValue===null||selectedValue===undefined||String(selectedValue)==='')return true;
      return String(variant.options[index])===String(selectedValue);
    });
  });
}

function refreshSoldOutOptions(){
  var selected=selectedOptionsFromDom();
  main.querySelectorAll('.variant-btn').forEach(function(button){
    var index=parseInt(button.dataset.optionIndex,10);
    if(Number.isNaN(index))return;
    var matches=candidateVariants(index,button.dataset.value,selected);
    if(!matches.length)return;
    var anyAvailable=matches.some(function(variant){return !!variant.available});
    if(anyAvailable){
      button.classList.remove('is-sold-out');
      return;
    }
    button.disabled=false;
    button.classList.remove('is-unavailable');
    button.classList.add('is-sold-out');
    button.setAttribute('aria-disabled','false');
    var label=(button.dataset.value||button.textContent||'').trim();
    if(label)button.setAttribute('aria-label',label+' — sold out, select for restock notification');
  });
}

function displayOptionName(name){
  var key=String(name||'').toLowerCase();
  if(key==='color')return 'Colour';
  if(key==='denominations')return 'Value';
  return name||'Option';
}

function selectionText(variant){
  if(!variant||!Array.isArray(variant.options))return '';
  return variant.options.map(function(value,index){return displayOptionName(optionNames[index])+': '+value}).join(' · ');
}

function syncTags(variant){
  if(tagsInput&&variant)tagsInput.value='Restock availability request for product '+restock.dataset.productId+', variant '+variant.id+' ('+selectionText(variant)+'). Reply only about this request; no marketing signup.';
}

function showSuccess(variant){
  restock.hidden=false;
  if(fields)fields.hidden=true;
  if(success)success.hidden=false;
  if(successSelection)successSelection.textContent=variant?selectionText(variant):'';
  if(status)status.textContent='';
}

function showForVariant(variant){
  if(standDownForXflow())return;
  var soldOut=!!(variant&&!variant.available);
  if(!soldOut){
    restock.hidden=true;
    return;
  }
  restock.hidden=false;
  if(selection)selection.textContent=selectionText(variant);
  syncTags(variant);
  if(fields)fields.hidden=false;
  if(success)success.hidden=true;
  if(status)status.textContent='';
}

function restoreSoldOutButtonsSoon(){
  window.requestAnimationFrame(function(){refreshSoldOutOptions()});
}

main.addEventListener('or:variant-change',function(event){
  var variant=event.detail&&event.detail.variant?event.detail.variant:null;
  showForVariant(variant);
  restoreSoldOutButtonsSoon();
});

if(form){
  form.addEventListener('submit',function(event){
    var variant=currentVariant();
    if(!variant||variant.available){
      event.preventDefault();
      if(status)status.textContent='Please select a sold-out option first.';
      return;
    }
    syncTags(variant);
    if(email&&typeof email.checkValidity==='function'&&!email.checkValidity()){
      event.preventDefault();
      if(typeof email.reportValidity==='function')email.reportValidity();
      return;
    }
    if(preferencesProcessingAllowed()){
      try{window.sessionStorage.setItem(storageKey,String(variant.id))}catch(error){}
    }
  });
}

refreshSoldOutOptions();
if('MutationObserver' in window){
  xflowObserver=new MutationObserver(function(){
    if(standDownForXflow())return;
  });
  xflowObserver.observe(document.documentElement,{childList:true,subtree:true});
  window.setTimeout(function(){standDownForXflow()},1200);
}
if(submittedSuccess)showSuccess(successVariant);else showForVariant(currentVariant());
})();
